module.exports = __webpack_public_path__ + "static/media/Interpreter and Translation Service.b1d1bde9.png";